import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export enum TableTypesEnum {
  All = 'All',
  Main = 'Main',
  Summary = 'Summary',
}

export const useTypeOptions = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });

  return useMemo(
    () => [
      { label: `${t('addTables.types.main')}`, value: TableTypesEnum.Main },
      { label: `${t('addTables.types.summary')}`, value: TableTypesEnum.Summary },
    ],
    [t],
  );
};
